export const saveBlob = (blob: Blob, filename: string) => {
	const blobUrl = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = blobUrl;
	a.download = filename;
	a.style.visibility = 'hidden';
	document.body.appendChild(a);
	a.click();
	URL.revokeObjectURL(blobUrl);
	document.body.removeChild(a);
};

export const getFilenameFromContentDisposition = (response: Response, defaultFilename: string) => {
	const contentDispositionHeader = response.headers.get('Content-Disposition');
	if (!contentDispositionHeader) {
		return defaultFilename;
	}

	const filename = contentDispositionHeader?.split('filename=')[1];
	if (!filename) {
		return defaultFilename;
	}

	return filename.replace(/['"]/g, '');
};
